// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enhanced-clips-metadata-page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.page-header h1 {
  margin: 0;
  color: #333;
  border-bottom: 2px solid #3498db;
  padding-bottom: 10px;
}

.video-info {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
}

.video-id {
  display: flex;
  gap: 8px;
  align-items: center;
}

.video-id .label {
  font-weight: 600;
  color: #555;
}

.video-id .value {
  font-family: monospace;
  background-color: #eef2f5;
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.chunk-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chunk-selector label {
  font-weight: 600;
  color: #555;
}

.chunk-selector select {
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
  font-size: 0.9rem;
  min-width: 100px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
}

.loader {
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #3498db;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-container {
  padding: 20px;
  background-color: #fff0f0;
  border-left: 4px solid #ff5555;
  margin-bottom: 20px;
  border-radius: 4px;
}

.error-message {
  color: #d32f2f;
  margin-bottom: 15px;
}

.retry-button {
  padding: 8px 16px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.retry-button:hover {
  background-color: #d32f2f;
}

.no-data {
  padding: 30px;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 8px;
  color: #777;
  font-style: italic;
} `, "",{"version":3,"sources":["webpack://./src/pages/css/EnhancedClipsMetadataPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".enhanced-clips-metadata-page {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-header {\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.page-header h1 {\n  margin: 0;\n  color: #333;\n  border-bottom: 2px solid #3498db;\n  padding-bottom: 10px;\n}\n\n.video-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: center;\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 8px;\n}\n\n.video-id {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.video-id .label {\n  font-weight: 600;\n  color: #555;\n}\n\n.video-id .value {\n  font-family: monospace;\n  background-color: #eef2f5;\n  padding: 5px 10px;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.chunk-selector {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chunk-selector label {\n  font-weight: 600;\n  color: #555;\n}\n\n.chunk-selector select {\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  font-size: 0.9rem;\n  min-width: 100px;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 50px 0;\n}\n\n.loader {\n  border: 3px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 3px solid #3498db;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-container {\n  padding: 20px;\n  background-color: #fff0f0;\n  border-left: 4px solid #ff5555;\n  margin-bottom: 20px;\n  border-radius: 4px;\n}\n\n.error-message {\n  color: #d32f2f;\n  margin-bottom: 15px;\n}\n\n.retry-button {\n  padding: 8px 16px;\n  background-color: #f44336;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.retry-button:hover {\n  background-color: #d32f2f;\n}\n\n.no-data {\n  padding: 30px;\n  text-align: center;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  color: #777;\n  font-style: italic;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
